import { createStore, RemoveOptionals } from '@driftt/dds'

import { FLFormAPIForm } from 'api/fastlane'

export interface FLWizardContextType {
  workspaceId?: string
  playbookName?: string
  form?: FLFormAPIForm
  selectedFormId?: string
  formUrl?: string
  isManualFL: boolean
  hasRedirect?: boolean
  redirectUrl?: string
  isDeferredSubmission: boolean
  testSuccess?: boolean
}

export const { Provider: FLWizardStoreProvider, useStore: useFLWizardStore } =
  createStore<FLWizardContextType>({
    isManualFL: false,
    isDeferredSubmission: false,
  })

export const validateFLWizardContext = (
  wizardStore: FLWizardContextType,
  { orgHasWorkspaces }: { orgHasWorkspaces: boolean }
): wizardStore is RemoveOptionals<FLWizardContextType> => {
  if (orgHasWorkspaces && !wizardStore.workspaceId) {
    return false
  }

  if (
    !wizardStore.playbookName ||
    wizardStore.form?.id == null ||
    !wizardStore.formUrl
  ) {
    return false
  }

  if (wizardStore.isDeferredSubmission) {
    return true
  }

  if (wizardStore.hasRedirect && !wizardStore.redirectUrl) {
    return false
  }

  return true
}
